import { render, staticRenderFns } from "./PersonalSearchList.vue?vue&type=template&id=d6f6bb06&scoped=true&"
import script from "./PersonalSearchList.vue?vue&type=script&lang=js&"
export * from "./PersonalSearchList.vue?vue&type=script&lang=js&"
import style0 from "./PersonalSearchList.vue?vue&type=style&index=0&id=d6f6bb06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6f6bb06",
  null
  
)

export default component.exports